import { render, staticRenderFns } from "./DiscussionResponseForm.vue?vue&type=template&id=208bbc79&"
import script from "./DiscussionResponseForm.vue?vue&type=script&lang=js&"
export * from "./DiscussionResponseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/kreston-is.sdev.cz/httpdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('208bbc79')) {
      api.createRecord('208bbc79', component.options)
    } else {
      api.reload('208bbc79', component.options)
    }
    module.hot.accept("./DiscussionResponseForm.vue?vue&type=template&id=208bbc79&", function () {
      api.rerender('208bbc79', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/forms/discussion/DiscussionResponseForm.vue"
export default component.exports